export default __webpack_public_path__ + "static/media/diners-single.c05f555b.svg";